import { LinkButtonWrapperProps } from "../../../types";
import { successOutlineClass, successSolidClass } from "./buttonStyles";
import { LinkButton } from "./LinkButton";

export const SuccessLinkButton = ({
  children,
  href,
  cssClass,
  variant = "solid",
  testId,
  onClick,
}: LinkButtonWrapperProps) => {
  return (
    <LinkButton
      href={href}
      testId={testId}
      onClick={() => onClick && onClick()}
      cssClass={`${
        variant === "outline" ? successOutlineClass : successSolidClass
      } ${cssClass ? cssClass : ""}`}
    >
      {children}
    </LinkButton>
  );
};
